import React, { useState, useCallback, useContext } from "react";
import Accordion from "../../shared/Accordion/Accordion";
import { Row ,Col ,FormGroup } from 'reactstrap';
import classnames from 'classnames';
import { ReactComponent as SearchIcon } from '../../../assets/images/search.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import styles from './Faqs.module.css';
import BootstrapTable from "react-bootstrap-table-next";
import { getBrandContent } from '../../BrandingWhiteLabel/BrandContent';
import { SessionContext } from "../../../context/SessionContext";
import ClientPhone from "../../shared/ClientPhone/ClientPhone";
import { Link } from 'react-router-dom';

const ComfortShieldprogramFaqs = ({ changeTab }) => {

  const [activeAccord, setActiveAccord] = useState(-1);
  const [search, setSearch] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const context = useContext(SessionContext);
  const { accountName } = context;
  const coverageType  = context?.getProfile().country.toLowerCase() === 'canada'? 'labour' : 'labor';
  const currentBrand = getBrandContent(accountName);
  const onToggle = useCallback((id) => {
    if (id === activeAccord) {
      setActiveAccord(-1);
    }
    else {
      setActiveAccord(id);
    }
  }, [activeAccord, setActiveAccord]);

  const capitalizeFirstLetter= (s) => {
    return s[0].toUpperCase() + s.slice(1);
  }
  const isLennox = currentBrand?.clientName?.toLowerCase() === 'lennox';
  const isCarrier = currentBrand?.clientName?.toLowerCase() === 'carrier';
  const isRheem = currentBrand?.clientName?.toLowerCase() === 'rheem';
  const isTrane = currentBrand?.clientName?.toLowerCase() === 'trane';
  const isGE = currentBrand?.clientName?.toLowerCase() === 'ge';
  const isICP = currentBrand?.clientName?.toLowerCase() === 'icp';
  const isHomeDepot = currentBrand?.clientName?.toLowerCase() === 'the home depot';
  const isMCC = currentBrand?.clientName?.toLowerCase() === 'mcc';
  const isNordyne = currentBrand?.clientName?.toLowerCase() === 'nordyne';
  const priceLevelName =  currentBrand?.pricingLevelName.charAt(0).toLowerCase() + currentBrand?.pricingLevelName.slice(1);
  const ratesColumns = [
    {
      dataField: "tierType",
      text: "Tier"
    },
    {
      dataField: "tripAmount",
      text: "Trip Amount"
    },
    {
      dataField: "laborRate",
      text: "Labor Rate"
    },
    {
      dataField: "timeToSell",
      text: "Time to Sell from Equipment Installation Date"
    }
  ];

  const ratesData = [
    {
      tierType: "Basic",
      tripAmount: "$65",
      laborRate: "$85",
      timeToSell: "Within nine (9) months"
    },
    {
      tierType: "Tier 1",
      tripAmount: "$85",
      laborRate: "$125",
      timeToSell: "Within sixty (60) months"
    },
    {
      tierType: "Tier 2",
      tripAmount: "$100",
      laborRate: "$175",
      timeToSell: "Within sixty (60) months"
    },
    {
      tierType: "Tier 3",
      tripAmount: "$125",
      laborRate: "$250",
      timeToSell: "Within sixty (60) months"
    }
  ];

  const lennoxAccordionContents = [
    {
      bodyContent: `Offering ${currentBrand.programName} warranties not only gives you an opportunity to clarify the manufacturer’s limited warranty, but also gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company too deserves protection from costly expenses related to consumer concessions, as well as to be reimbursed for your services when unexpected failures occur in the early months or years following installations.`,
      title: `Why should I offer my consumers ${currentBrand.programName} extended warranties?`
    },
    {
      bodyContent: `Yes, ${currentBrand.programName} is a comprehensive solution which allows you to manage all of your extended warranty business through one program - no matter the brand.`,
      title: `If I sell brands other than Lennox, will ${currentBrand.programName} cover that equipment too?`
    },
    {
      bodyContent: `${currentBrand.programName} warranties cover repairs needed as a result of mechanical and electrical failures. Depending on the tier purchased, coverage will extend to other items such as refrigerant, parts mark up, and miscellaneous parts that may be needed to complete repairs.`,
      title: `What do ${currentBrand.programName} extended warranties cover?`
    },
    {
      bodyContent: `The labor portion of warranties can begin as early as ninety-one (91) days from installation date. If parts are included in the warranty sold then coverage begins upon expiration of the factory parts warranty. For all labor coverage, effective dates will be ninety (91) days after the contract is received by ${currentBrand.programName}.`,
      title: `When will the ${currentBrand.programName} warranty take effect?`
    },
    {
      bodyContent: `If your company has a credit account with Lennox you will be invoiced for the sales through normal invoicing procedures you have with Lennox. All payments for contracts should be remitted to Lennox. If your company does not have a credit account with Lennox then payment via credit card will be required during the sales entry process.`,
      title: `How do I pay for ${currentBrand.programName} warranties that my consumers purchase?`
    },
    {
      bodyContent: `No, consumers that purchase ${currentBrand.programName} extended warranties will not be required to pay a deductible when setting up a service call.`,
      title: `Will my consumer be required to pay a deductible if they need to set up service?`
    },
    {
      bodyContent: `Yes, if your company sells ${currentBrand.programName} warranties to consumers then you will have first right of refusal for all service calls that may be needed.  Your company information will also print on the certificate of coverage that consumers will receive once the warranty is purchased.`,
      title: `Will I be the preferred servicer for consumers that purchase a ${currentBrand.programName} warranty from my company?`
    },
    {
      bodyContent: (
        <>
          During factory warranty you must follow the OEM’s replacement procedure and guidelines.
          If the equipment is out of factory warranty and covered by {currentBrand.programName} please call at
          <ClientPhone customClass="mx-1" />
          to notify us of the replacement and to receive an authorization number that will be used when filing claims.
        </>
      ),
      title: `Am I required to obtain authorization prior to replacing equipment?`
    },
    {
      bodyContent: `Annual maintenance is recommended according to the OEM specifications. Proof of annual maintenance may be requested.`,
      title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
    },
    {
      bodyContent: `New equipment and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months of installation. Reimbursement tiers available for purchase vary based on date of previously installed equipment.`,
      title: `Are ${currentBrand.programName} extended warranties only offered on new installations?`
    },
    {
      bodyContent: (
        <>
          <p>{currentBrand.programName} warranties have multiple reimbursement tiers so trip and labor rates will vary depending on the warranty sold. Reimbursement Tiers are as follows:</p>
          <div className={styles.ratesTable}>
            <BootstrapTable
              keyField="tierType"
              data={ratesData}
              columns={ratesColumns}
              bordered={true}
              bootstrap4
              wrapperClasses="table-responsive"
            />
          </div>
        </>
      ),
      title: "What trip and/or labor rates will I be paid for completed repairs?"
    },
  ];

  const rheemAccordionContents = [
        {
            bodyContent: `Offering ${coverageType} coverage not only gives you an opportunity to clarify the manufacturer’s limited warranty, but also gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company also deserves reimbursement protection for your services when unexpected failures occur in the early months or years following installations.`,
            title: `Why should I offer my consumers ${currentBrand.programName} extended service agreements(ESAs)?`
        },
        {
            bodyContent: `${currentBrand.clientName} and Ruud brands are covered by ${currentBrand.programName} – not all of the ${currentBrand.clientName} family brands. `,
            title: `Will ${currentBrand.programName} cover any brand of equipment?`
        },
        {
            bodyContent: `We have options available for all residential heating and cooling equipment: split systems, individual products, packaged units, mini-split systems, zone systems and accessories.`,
            title: `What products are eligible for coverage?`
        },
        {
            bodyContent: (<>Our plans cover repairs for mechanical and electrical failures due to defects in materials and workmanship. View coverage type details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 2 within the Resources Card.*</>),
            title: `What do ${currentBrand.programName} ESAs cover? `
        },
        {
            bodyContent: `If parts are covered in the plan sold, then coverage begins upon expiration of the factory parts warranty. ${capitalizeFirstLetter(coverageType)} coverage can begin as early as thirty (30) days from plan purchase date.* `,
            title: `When will the ${currentBrand.programName} ESA take effect?`
        },
        {
            bodyContent: `Payment via credit card will be required during the order entry process. You will have the ability to save your preferred payment method to assist in an efficient and friendly checkout process.`,
            title: `How do I pay for ${currentBrand.programName} ESAs that my consumers purchase?`
        },
        {
            bodyContent: `New and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months from installation. Reimbursement options available for purchase vary based on date of previously installed equipment.*`,
            title: `Are ${currentBrand.programName} ESAs only offered on new installations?`
        },
        {
            bodyContent: `No, consumers that purchase ${currentBrand.programName} extended service agreements will not be required to pay a deductible when setting up a service call.`,
            title: `Will my consumer be required to pay a deductible if they need to set up service?`
        },
        {
            bodyContent: `Yes, if your company sells an extended service agreement, then you will have first right of refusal for all service calls that may be needed. Your company information will also be printed on the certificate of coverage that consumers will receive once the agreement is purchased.`,
            title: `Will I be the preferred servicer for consumers that purchase a ${currentBrand.programName} ESA from my company?`
        },
        {
            bodyContent: `During factory warranty you must follow the OEM’s replacement procedure and guidelines. If the equipment is out of factory warranty and covered by ${currentBrand.programName}, please call ${currentBrand.programPhone} to notify us of the replacement.`,
            title: `Am I required to obtain authorization prior to replacing equipment?`
        },
        {
            bodyContent: `Annual maintenance must be completed per the manufacturer’s specifications. Proof of annual maintenance for the covered equipment may be requested during claims processing.`,
            title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
        },
        {
            bodyContent: (
                <>
                    <p>
                        {currentBrand.programName} extended service agreements have multiple reimbursement {currentBrand.pricingLevelName.toLowerCase()}s. Trip and {coverageType} rates will vary depending on the agreement sold. <br />
                    </p>
                        View reimbursement {currentBrand.pricingLevelName.toLowerCase()} details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 1 within the Resources Card.
                </>
            ),
            title: `What trip and ${coverageType} rates will I be paid for completed repairs?`
        }
    ];
    

  const carrierAccordionContents = [
    {
      bodyContent: `${currentBrand.programName} is an extended service agreement (ESA) that financially prepares HVAC customers for unexpected and unbudgeted repairs after the manufacturer’s limited warranty expires.  Additionally, ${currentBrand.programName} can be offered to HVAC customers to cover labor charges, while the manufacturer’s limited parts warranty is still active.  Offering ${currentBrand.programName} to customers is a great way to gain repeated business, increase profits and develop lasting client relationships.`,
      title: `What is ${currentBrand.programName}?`
    },
    {
      bodyContent: `Offering ${currentBrand.programName} warranties not only gives you an opportunity to clarify the manufacturer’s limited warranty, but also gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company too deserves protection from costly expenses related to consumer concessions, as well as to be reimbursed for your services when unexpected failures occur in the early months or years following installations.`,
      title: `Why should I offer my consumers ${currentBrand.programName} extended warranties?`
    },
    {
      bodyContent: `The ${currentBrand.programName} program is an option for all ${currentBrand.clientName} family brands.`,
      title: `If I sell brands other than ${currentBrand.clientName} family brands, will ${currentBrand.programName} cover that equipment too?`
    },
    {
      bodyContent: (
        <>
          Covered repairs needed as a result of mechanical and electrical failures are covered. Options are:
          <ul>
            <li>Labor Only: Time for labor and a trip/diagnostic fee.</li>
            <li>Labor Plus: Time for labor, a trip/diagnostic fee, and an allowance for parts.</li>
            <li>Parts Only: Cost of the covered part(s) replaced during the repair. No time for labor and no trip/diagnostic fees is included.</li>
            <li>Parts &amp; Labor: Time for labor, a trip/diagnostic fee, part allowance, and cost of the covered part(s) replaced during the repair.</li>
          </ul>
        </>
      ),
      title: `What do ${currentBrand.programName} extended warranties cover?`
    },
    {
      bodyContent: (
        <>
          <ul>
            <li>{currentBrand.standardPlanName} Plans are the existing program structure that are designed with a flat rate reimbursement structure and generally includes increased repair time and additional reimbursement when compared with typical 3rd party warranty providers.</li>
            <li>The new level, {currentBrand.valuePlanName}, is designed with a time and material reimbursement structure. While the total reimbursement is less when compared to the Standard Plans, it is in line with the competition and allows for a reduced, more aggressive, up front contract price.</li>
          </ul>
        </>
      ),
      title: `What is the difference between ${currentBrand.programName} ${currentBrand.valuePlanName} and ${currentBrand.standardPlanName} Plans?`
    },
    {
      bodyContent: `The labor portion of warranties can begin as early as thirty-one (31) days from installation date. If parts are included in the warranty sold, then coverage begins upon expiration of the factory parts warranty. For all labor coverage, effective dates will be thirty-one (31) days after the contract is purchased through ${currentBrand.programName}.  If coverage is purchased 1 year or more from installation date, the effective date will be ninety-one (91) days after the contract is purchased.`,
      title: `When will the ${currentBrand.programName} warranty take effect?`
    },
    {
      bodyContent: `Payment via credit card will be required during the order entry process.  Dealers will have the ability to save your preferred payment method to assist in an efficient and friendly checkout process.`,
      title: `How do I pay for ${currentBrand.programName} warranties that my consumers purchase?`
    },
    {
      bodyContent: `No, consumers that purchase ${currentBrand.programName} extended warranties will not be required to pay a deductible when setting up a service call.`,
      title: `Will my consumer be required to pay a deductible if they need to set up service?`
    },
    {
      bodyContent: `Yes, if your company sells ${currentBrand.programName} warranties to consumers then you will have first right of refusal for all service calls that may be needed. Your company information will also print on the certificate of coverage that is mailed out, for customers to contact for service needs.`,
      title: `Will I be the preferred servicer for consumers that purchase a ${currentBrand.programName} warranty from my company?`
    },
    {
      bodyContent: `Preauthorization is not required.  Simply diagnose and repair the customer’s issue and once complete submit your claim and invoice documentation to ${currentBrand.programName} for review and claim payment for covered repairs.`,
      title: `Am I required to obtain authorization prior to replacing equipment?`
    },
    {
      bodyContent: `Annual maintenance is recommended by the OEM specifications. Proof of annual maintenance may be requested.`,
      title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
    },
    {
      bodyContent: `New equipment and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months of installation.  The wait period for coverage sold beyond 1 Year from installation, will increase from the standard 30 day wait period, to 90 days.`,
      title: `Are ${currentBrand.programName} extended warranties only offered on new installations?`
    }
  ];

  const traneAccordionContents = [
    {
      bodyContent: `Offering ${coverageType} coverage not only gives you an opportunity to clarify the manufacturer’s limited warranty, but also gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company also deserves reimbursement protection for your services when unexpected failures occur in the early months or years following installations.`,
      title: `Why should I offer my consumers ${currentBrand.programName} extended service agreements (ESAs)?`
    },
    {
      bodyContent: `Only ${currentBrand.clientName} and American Standard brands are eligible for coverage under ComfortSure – not all family brands.`,
      title: `Will ${currentBrand.programName} cover any brand of equipment?`
    },
    {
      bodyContent: `We have options available for all residential heating and cooling equipment: split systems, individual products, packaged units, mini-split systems, zone systems and accessories.`,
      title: `What products are eligible for coverage?`
    },
    {
      bodyContent: (<>Our plans cover repairs for mechanical and electrical failures due to defects in materials and workmanship. View coverage type details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 2 within the Resources Card.*</>),
      title: `What do ${currentBrand.programName} ESAs cover?`
    },
    {
      bodyContent: (
        <>
          <p>
            Standard Plans are the existing program structure that are designed
            with a flat rate reimbursement structure and generally includes increased
            repair time and additional reimbursement when compared with typical third party warranty providers.
          </p>
             The new level, Value, is designed with a time and material reimbursement structure.
             While the total reimbursement is less when compared to the Standard Plans, it is in line
             with the competition and allows for a reduced, more aggressive, upfront contract price.
        </>
      ),
      title: `What is the difference between Standard and Value?`
    },
    {
      bodyContent: `If parts are covered in the plan sold, then coverage begins upon expiration of the factory parts warranty. ${capitalizeFirstLetter(coverageType)} coverage can begin as early as thirty (30) days from plan purchase date.*`,
      title: `When will the ${currentBrand.programName} ESA take effect?`
    },
    {
      bodyContent: `Payment via credit card will be required during the order entry process. You will have the ability to save your preferred payment method to assist in an efficient and friendly checkout process.`,
      title: `How do I pay for ${currentBrand.programName} ESAs that my consumers purchase?`
    },
    {
      bodyContent: `New and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months from installation. Reimbursement options available for purchase vary based on date of previously installed equipment.*`,
      title: `Are ${currentBrand.programName} ESAs only offered on new installations?`
    },
    {
      bodyContent: `No, consumers that purchase ${currentBrand.programName} extended service agreements will not be required to pay a deductible when setting up a service call.`,
      title: `Will my consumer be required to pay a deductible if they need to set up service?`
    },
    {
      bodyContent: `Yes, if your company sells an extended service agreement, then you will have first right of refusal for all service calls that may be needed. Your company information will also be printed on the certificate of coverage that consumers will receive once the agreement is purchased.`,
      title: `Will I be the preferred servicer for consumers that purchase a ${currentBrand.programName} ESA from my company?`
    },
    {
      bodyContent: `During factory warranty you must follow the OEM’s replacement procedure and guidelines. If the equipment is out of factory warranty and covered by ${currentBrand.programName}, please call ${currentBrand.programPhone} to notify us of the replacement.`,
      title: `Am I required to obtain authorization prior to replacing equipment?`
    },
    {
      bodyContent: `Annual maintenance must be completed per the manufacturer’s specifications. Proof of annual maintenance for the covered equipment may be requested during claims processing.`,
      title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
    },
    {
      bodyContent: (
        <>
          <p>
            {currentBrand.programName} extended service agreements have multiple reimbursement {currentBrand.pricingLevelName.toLowerCase()}s. Trip and {coverageType} rates will vary depending on the agreement sold. <br/> 
          </p>
            View reimbursement {currentBrand.pricingLevelName.toLowerCase()} details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 1 within the Resources Card. 
        </>
      ),
      title: `What trip and ${coverageType} rates will I be paid for completed repairs?`
    },
  ];

    const MccAccordionContents = [
        {
            bodyContent: `Offering ${coverageType} coverage not only gives you an opportunity to clarify the manufacturer’s limited warranty, but also gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company also deserves reimbursement protection for your services when unexpected failures occur in the early months or years following installations.`,
            title: `Why should I offer my consumers ${currentBrand.programName} extended service agreements (ESAs)?`
        },
        {
            bodyContent: `Yes, ${currentBrand.programName} is a comprehensive solution which allows you to manage all your extended service agreement business through one program - no matter the brand. `,
            title: `Will ${currentBrand.programName} cover any brand of equipment? `
        },
        {
            bodyContent: `We have options available for all residential heating and cooling equipment: split systems, individual products, packaged units, mini-split systems, zone systems and accessories. `,
            title: `What products are eligible for coverage? `
        },
        {
            bodyContent: (<>Our plans cover repairs for mechanical and electrical failures due to defects in materials and workmanship. View coverage type details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 2 within the Resources Card.*</>),
            title: `What do ${currentBrand.programName} ESAs cover? `
        },
        {
            bodyContent: `If parts are covered in the plan sold, then coverage begins starting in year six (6). ${capitalizeFirstLetter(coverageType)} coverage can begin as early as thirty (30) days from plan purchase date.*`,
            title: `When will the ${currentBrand.programName} ESA take effect? `
        },
        {
            bodyContent: `Payment via credit card will be required during the order entry process. You will have the ability to save your preferred payment method to assist in an efficient and friendly checkout process. `,
            title: `How do I pay for ${currentBrand.programName} ESAs that my consumers purchase? `
        },
        {
            bodyContent: `New and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months from installation. Reimbursement options available for purchase vary based on date of previously installed equipment.`,
            title: `Are ${currentBrand.programName} ESAs only offered on new installations?`
        },
        {
            bodyContent: `No, consumers that purchase ${currentBrand.programName} extended service agreements will not be required to pay a deductible when setting up a service call. `,
            title: `Will my consumer be required to pay a deductible if they need to set up service? `
        },
        {
            bodyContent: `Yes, if your company sells an extended service agreement, then you will have first right of refusal for all service calls that may be needed. Your company information will also be printed on the certificate of coverage that consumers will receive once the agreement is purchased.`,
            title: `Will I be the preferred servicer for consumers that purchase a ${currentBrand.programName} ESA from my company? `
        },
        {
            bodyContent: `During factory warranty you must follow the OEM’s replacement procedure and guidelines. If the equipment is out of factory warranty and covered by ${currentBrand.programName}, please call ${currentBrand.programPhone} to notify us of the replacement.`,
            title: `Am I required to obtain authorization prior to replacing equipment?`
        },
        {
            bodyContent: `Annual maintenance must be completed per the manufacturer’s specifications. Proof of annual maintenance for the covered equipment may be requested during claims processing. `,
            title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
        },
        {
            bodyContent: (
                <>
                    <p>
                        {currentBrand.programName} extended service agreements have multiple reimbursement {currentBrand.pricingLevelName.toLowerCase()}s. Trip and {coverageType} rates will vary depending on the agreement sold. <br />
                    </p>
                        View reimbursement {currentBrand.pricingLevelName.toLowerCase()} details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 1 within the Resources Card.
                </>
            ),
            title: `What trip and ${coverageType} rates will I be paid for completed repairs? `
        }
    ];

  const reimbursementColumnsGE = [
    {
      dataField: "reimbursementPlanType",
      text: "Plans"
    },
    {
      dataField: "trip",
      text: "Trip"
    },
    {
      dataField: "laborRate",
      text: "Labor"
    }
  ];

  const reimbursementDataGE = [
    {
      reimbursementPlanType: 'Plan 1',
      trip: "$65",
      laborRate: "$85"
    },
    {
      reimbursementPlanType: 'Plan 2',
      trip: "$85",
      laborRate: "$125"
    },
    {
      reimbursementPlanType: 'Plan 3',
      trip: "$85",
      laborRate: "$200"
    }
  ];
  
  const geAccordionContents = [
    {
      bodyContent: `Offering extended service agreements with ${currentBrand.programName} gives you the opportunity to clarify the manufacturer’s limited warranty and gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company too deserves protection from costly expenses related to consumer concessions, as well as to be reimbursed for your services when unexpected failures occur in the early months or years following installations.`,
      title: `Why should I offer my consumers ${currentBrand.programName} extended service agreements?`
    },
    {
      bodyContent: `Yes, ${currentBrand.programName} is a comprehensive solution which allows you to manage all your extended service agreements through one program - no matter the brand.`,
      title: `If I sell brands other than ${currentBrand.clientName}, will ${currentBrand.programName} cover that equipment too?`
    },
    {
      bodyContent: `${currentBrand?.programName} ${priceLevelName}s reimburse covered repairs needed as a result of mechanical and electrical failures.  See program terms and conditions and dealer enrollment guidelines for further information, including program labor rates.`,
      title: `What does ${currentBrand?.programName} extended service agreements cover?`
    },
    {
      bodyContent: `The labor portion of the plan can begin as early as thirty-one (31) days from installation date. If parts are included in the warranty sold, then parts coverage begins upon expiration of the factory parts warranty. For all labor coverage, effective dates will be thirty-one (31) days after the contract is received by ${currentBrand.programName}.`,
      title: `When will the ${currentBrand.programName} extended service agreement take effect?`
    },
    {
      bodyContent: `Our user-friendly websites will allow you to pay at point of purchase for each extended service agreement. Payment methods accepted include Visa, MasterCard, Discover and American Express in the form of a credit or debit card.`,
      title: `How do I pay for ${currentBrand.programName} extended service agreements that my consumers purchase?`
    },
    {
      bodyContent: `No, consumers that purchase ${currentBrand.programName} extended service agreements will not be required to pay a deductible when setting up a service call.`,
      title: `Will my consumer be required to pay a deductible if they need to schedule service?`
    },
    {
      bodyContent: `Yes, if your company sells ${currentBrand.programName} extended service agreements to consumers, then you will have first right of refusal for all service calls that may be needed. Your company information will also be printed on the certificate of coverage that consumers will receive once the plan is purchased.`,
      title: `Will I be the preferred servicer for consumers that purchase a ${currentBrand.programName} extended service agreement from my company?`
    },
    {
      bodyContent: `Yes, annual maintenance is a requirement of the program and must be completed per the manufacturer’s specifications.  If selected during claims processing, proof of annual maintenance of the covered equipment may be requested.`,
      title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
    },
    {
      bodyContent: `New equipment and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months of installation. If purchased after twelve (12) months from installation, wait period is increased to ninety (90) days versus thirty (30) days if purchased within the first twelve (12) months from installation.`,
      title: `Are ${currentBrand.programName} extended service agreements only offered on new installations?`
    },
    {
      bodyContent: (
        <>
          <p>{currentBrand?.programName} extended service agreements have multiple reimbursement {priceLevelName}s so trip and labor rates will vary depending on the plan sold. Reimbursement {priceLevelName}s are as follows:</p>
          <div className={classnames(styles.reimbursementRatesTable, styles.reimbursementRatesTableGE)}>
            <BootstrapTable
              keyField="reimbursementType"
              data={reimbursementDataGE}
              columns={reimbursementColumnsGE}
              bordered={true}
              bootstrap4
              wrapperClasses="table-responsive"
            />
          </div>
          <p> See the program’s dealer enrollment terms and conditions and guidelines for further details.</p>
        </>
      ),
      title: `What trip and/or labor rates will I be paid for completed repairs?`
    }
  ];
  const icpAccordianContents = [
    {
      bodyContent: `Offering ${coverageType} coverage not only gives you an opportunity to clarify the manufacturer’s limited warranty, but also gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company also deserves reimbursement protection for your services when unexpected failures occur in the early months or years following installations.`,
      title: `Why should I offer my consumers ${currentBrand.programName} extended service agreements(ESAs)?`
    },
    {
      bodyContent: `All ${currentBrand.clientName} family brands are covered under the ${currentBrand.programName} program.`,
      title: `Will ${currentBrand.programName} cover any brand of equipment?`
    },
    {
      bodyContent: `We have options available for all residential heating and cooling equipment: split systems, individual products, packaged units, mini-split systems, zone systems and accessories.`,
      title: `What products are eligible for coverage?`
    },
    {
      bodyContent: (<>Our plans cover repairs for mechanical and electrical failures due to defects in materials and workmanship. View coverage type details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 2 within the Resources Card.*</>),
      title: `What do ${currentBrand.programName} ESAs cover? `
    },
    {
      bodyContent: `If parts are covered in the plan sold, then coverage begins upon expiration of the factory parts warranty. ${capitalizeFirstLetter(coverageType)} coverage can begin as early as thirty (30) days from plan purchase date.* `,
      title: `When will the ${currentBrand.programName} ESA take effect?`
    },
    {
      bodyContent: `Payment via credit card will be required during the order entry process. You will have the ability to save your preferred payment method to assist in an efficient and friendly checkout process.`,
      title: `How do I pay for ${currentBrand.programName} ESAs that my consumers purchase?`
    },
    {
      bodyContent: `New and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months from installation. Reimbursement options available for purchase vary based on date of previously installed equipment.*`,
      title: `Are ${currentBrand.programName} ESAs only offered on new installations?`
    },
    {
      bodyContent: `No, consumers that purchase ${currentBrand.programName} extended service agreements will not be required to pay a deductible when setting up a service call.`,
      title: `Will my consumer be required to pay a deductible if they need to set up service?`
    },
    {
      bodyContent: `Yes, if your company sells an extended service agreement, then you will have first right of refusal for all service calls that may be needed. Your company information will also be printed on the certificate of coverage that consumers will receive once the agreement is purchased.`,
      title: `Will I be the preferred servicer for consumers that purchase a ${currentBrand.programName} ESA from my company?`
    },
    {
      bodyContent: `During factory warranty you must follow the OEM’s replacement procedure and guidelines. If the equipment is out of factory warranty and covered by ${currentBrand.programName}, please call ${currentBrand.programPhone} to notify us of the replacement.`,
      title: `Am I required to obtain authorization prior to replacing equipment?`
    },
    {
      bodyContent: `Annual maintenance must be completed per the manufacturer’s specifications. Proof of annual maintenance for the covered equipment may be requested during claims processing.`,
      title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
    },
    {
      bodyContent: (
        <>
          <p>
            {currentBrand.programName} extended service agreements have multiple reimbursement {currentBrand.pricingLevelName.toLowerCase()}s. Trip and {coverageType} rates will vary depending on the agreement sold. <br/> 
          </p>
          <p>
            View reimbursement {currentBrand.pricingLevelName.toLowerCase()} details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 1 within the Resources Card. 
          </p>
        </>
      ),
      title: `What trip and ${coverageType} rates will I be paid for completed repairs?`
    }
    ];

  const hdAccordianContents = [
    {
      bodyContent: `Offering ${coverageType} coverage not only gives you an opportunity to clarify the manufacturer’s limited warranty, but also gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company also deserves reimbursement protection for your services when unexpected failures occur in the early months or years following installations.`,
      title: `Why should I offer my consumers ${currentBrand.programName}s?`
    },
    {
      bodyContent: `Yes, ${currentBrand.programName} is a comprehensive solution which allows you to manage all your extended service agreement business through one program - no matter the brand.`,
      title: `Will ${currentBrand.programName} cover any brand of equipment?`
    },
    {
      bodyContent: `We have options available for all residential heating and cooling equipment: split systems, individual products, packaged units, mini-split systems, zone systems and accessories.`,
      title: `What products are eligible for coverage?`
    },
    {
      bodyContent: (<>Our plans cover repairs for mechanical and electrical failures due to defects in materials and workmanship. View coverage type details in {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 2 within the Resources Card.* </>),
      title: `What do ${currentBrand.programName}s cover?`
    },
    {
      bodyContent: `If parts are covered in the plan sold, then coverage begins starting in year six (6).  ${coverageType.charAt(0).toUpperCase() + coverageType.slice(1)} coverage can begin as early as thirty (30) days from plan purchase date.* `,
      title: `When will ${currentBrand.programName} take effect?`
    },
    {
      bodyContent: `Payment via credit card will be required during the order entry process. You will have the ability to save your preferred payment method to assist in an efficient and friendly checkout process.`,
      title: `How do I pay for ${currentBrand.programName}s that my consumers purchase?`
    },
    {
      bodyContent: `New and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months from installation. Reimbursement options available for purchase vary based on date of previously installed equipment.* `,
      title: `Are ${currentBrand.programName}s only offered on new installations?`
    },
    {
      bodyContent: `No, consumers that purchase  ${currentBrand.programName} will not be required to pay a deductible when setting up a service call.`,
      title: `Will my consumer be required to pay a deductible if they need to set up service?`
    },
    {
      bodyContent: `Yes, if your company sells ${currentBrand.programName}, then you will have first right of refusal for all service calls that may be needed. Your company information will also be printed on the certificate of coverage that consumers will receive once the agreement is purchased.`,
      title: `Will I be the preferred servicer for consumers that purchase  ${currentBrand.programName}s from my company?`
    },
    {
      bodyContent: `During factory warranty you must follow the OEM’s replacement procedure and guidelines. If the equipment is out of factory warranty and covered by ${currentBrand.programName}, please call ${currentBrand.programPhone} to notify us of the replacement and to receive an authorization number to be used when filing claims.`,
      title: `Am I required to obtain authorization prior to replacing equipment?`
    },
    {
      bodyContent: `Annual maintenance must be completed per the manufacturer’s specifications. Proof of annual maintenance for the covered equipment may be requested during claims processing.`,
      title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
    },
    {
      bodyContent: (
        <>
          <p>{currentBrand.programName}s have multiple reimbursement {currentBrand.pricingLevelName.toLowerCase()}s. Trip and {coverageType} rates will vary depending on the plan sold. 
          </p>
          <div>
            View reimbursement {currentBrand.pricingLevelName.toLowerCase()} details in {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 1 within the Resources Card. 
          </div>
        </>
      ),
      title: `What trip and ${coverageType} rates will I be paid for completed repairs?`
    }
  ];

  const nordyneAccordianContents = [
    {
      bodyContent: `Offering ${coverageType} coverage not only gives you an opportunity to clarify the manufacturer’s limited warranty, but also gives your consumers the choice to be protected from costly out-of-pocket expenses should failures occur. Your company also deserves reimbursement protection for your services when unexpected failures occur in the early months or years following installations.`,
      title: `Why should I offer my consumers ${currentBrand.programName} ESAs?`
    },
    {
      bodyContent: `All ${currentBrand.clientName} family brands are covered under the ${currentBrand.programName}.`,
      title: `Will ${currentBrand.programName} cover any brand of equipment?`
    },
    {
        bodyContent: `We have options available for all residential heating and cooling equipment: split systems, individual products, packaged units, mini-split systems, zone systems and accessories.`,
        title: `What products are eligible for coverage?`
    },
    {
        bodyContent: (<>Our plans cover repairs for mechanical and electrical failures due to defects in materials and workmanship. View coverage type details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 2 within the Resources Card.*</>),
        title: `What do ${currentBrand.programName} ESAs cover? `
    },
    {
        bodyContent: `If parts are covered in the plan sold, then coverage begins upon expiration of the factory parts warranty. ${capitalizeFirstLetter(coverageType)} coverage can begin as early as thirty (30) days from plan purchase date.*`,
        title: `When will the ${currentBrand.programName} ESA take effect? `
    },
    {
        bodyContent: `Payment via credit card will be required during the order entry process. You will have the ability to save your preferred payment method to assist in an efficient and friendly checkout process. `,
        title: `How do I pay for ${currentBrand.programName} ESAs that my consumers purchase? `
    },
    {
        bodyContent: `New and previously installed equipment are eligible for coverage. Previously installed equipment must be in good working condition and coverage must be sold within sixty (60) months from installation. Reimbursement options available for purchase vary based on date of previously installed equipment.* `,
        title: `Are ${currentBrand.programName} ESAs only offered on new installations? `
    },
    {
      bodyContent: `No, consumers that purchase ${currentBrand.programName} ESAs will not be required to pay a deductible when setting up a service call. `,
      title: `Will my consumer be required to pay a deductible if they need to set up service? `
    },
    {
      bodyContent: `Yes, if your company sells an extended service agreement, then you will have first right of refusal for all service calls that may be needed. Your company information will also be printed on the certificate of coverage that consumers will receive once the agreement is purchased. `,
      title: `Will I be the preferred servicer for consumers that purchase a ${currentBrand.programName} ESA from my company? `
    },
    {
      bodyContent: `During factory warranty you must follow the OEM’s replacement procedure and guidelines. If the equipment is out of factory warranty and covered by ${currentBrand.programName}, please call ${currentBrand.programPhone} to notify us of the replacement.`,
      title: `Am I required to obtain authorization prior to replacing equipment? `
    },
    {
        bodyContent: `Annual maintenance must be completed per the manufacturer’s specifications. Proof of annual maintenance for the covered equipment may be requested during claims processing. `,
        title: `Is annual maintenance required on equipment covered by ${currentBrand.programName}?`
    },
    {
      bodyContent: (
        <>
          <p>
            {currentBrand.programName} ESAs have multiple reimbursement {currentBrand.pricingLevelName.toLowerCase()}s. Trip and {coverageType} rates will vary depending on the agreement sold. <br/> 
          </p>
            View reimbursement {currentBrand.pricingLevelName.toLowerCase()} details in the {currentBrand.programName} portal under <Link to='' onClick={() => changeTab(1, { data: 'salesAids', display: "Sales Aids" })}>Plan Options</Link> Step 1 within the Resources Card. 
        </>
      ),
      title: `What trip and ${coverageType} rates will I be paid for completed repairs?`
    }
  ];

  const filterSearch = acc => {
    const { title, bodyContent } = acc;
    return (typeof title === "string" && title.toLowerCase().includes(tempSearch)) || (typeof bodyContent === "string" && bodyContent.toLowerCase().includes(tempSearch));
  }

  const clientContents = () => {
    if (isLennox) {
      return lennoxAccordionContents;
    } else if (isRheem) {
      return rheemAccordionContents;
    } else if (isCarrier) {
      return carrierAccordionContents;
    } else if (isICP) {
      return icpAccordianContents;
    } else if (isHomeDepot) {
      return hdAccordianContents;
    } else if (isMCC) {
      return MccAccordionContents;
    } else if (isTrane) {
      return traneAccordionContents;
    } else if (isNordyne) {
      return nordyneAccordianContents;
    } else {
      return geAccordionContents;
    }
  }

  const contents = clientContents()
    .filter(filterSearch)
    .map((accord, i) => {
      if (search.length === 0) {
        (i < 9) ?
          (accord.title = `0${i + 1}. ${accord.title}`)
          :
          (accord.title = `${i + 1}. ${accord.title}`)
      }
      return <Accordion key={i} id={i} open={i === activeAccord} {...accord} onToggle={onToggle} />
    });

  return (
    <>
      <h1 className="h6">How can we help?</h1>
      <FormGroup className="col-md-4 col-lg-3 p-0">
        <input
          type="search"
          name="search"
          id="exampleSearch"
          placeholder="Search"
          className="form-control"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setTempSearch(e.target.value.trim().toLowerCase());
          }}
        />
        {search.length > 0 ? (
          <CloseIcon
            className={styles.closeIcon}
            onClick={() => {
              setSearch("");
              setTempSearch("");
            }}
          />
        ) : (
          <SearchIcon className={styles.searchIcon} />
        )}
      </FormGroup>
      {contents.length > 0 ? contents : <h3>0 Results Found</h3>}
      {isICP && (
        <Row>
          <Col>
            <p>
              *Service plans are subject to detailed terms, conditions, and
              limitations, including exclusions for specific parts and failures.
              Wait periods and labor/parts reimbursement rates may vary
              depending on the plan purchased. See the dealer guidelines and
              sample terms and conditions for complete coverage details.
            </p>
          </Col>
        </Row>
      )}
      {isHomeDepot && (
        <Row>
          <Col>
            <p>
              *Service plans are subject to detailed terms, conditions, and
              limitations, including exclusions for specific parts and failures.
              Wait periods and labor/parts reimbursement rates may vary depending on
              the plan purchased. See the dealer guidelines and sample terms and
              conditions for complete coverage details.
            </p>
          </Col>
        </Row>
      )}
      {isRheem && (
        <Row>
          <Col>
            <p>
              *Service plans are subject to detailed terms, conditions, and
              limitations, including exclusions for specific parts and failures.
              Wait periods and labor/parts reimbursement rates may vary
              depending on the plan purchased. See the dealer guidelines and
              sample terms and conditions for complete coverage details.
            </p>
          </Col>
        </Row>
      )}
      {isMCC && (
        <Row>
          <Col>
            <p>
              *Service plans are subject to detailed terms, conditions, and
              limitations, including exclusions for specific parts and failures.
              Wait periods and labor/parts reimbursement rates may vary depending on
              the plan purchased. See the dealer guidelines and sample terms and
              conditions for complete coverage details.
            </p>
          </Col>
        </Row>
      )}
      {isTrane && (
        <Row>
          <Col>
            <p>
              *Service plans are subject to detailed terms, conditions, and
              limitations, including exclusions for specific parts and failures.
              Wait periods and labor/parts reimbursement rates may vary depending on
              the plan purchased. See the dealer guidelines and sample terms and
              conditions for complete coverage details.
            </p>
          </Col>
        </Row>
      )}
      {isNordyne && (
        <Row>
          <Col>
            <p>
              *Service plans are subject to detailed terms, conditions, and
              limitations, including exclusions for specific parts and failures.
              Wait periods and labor/parts reimbursement rates may vary depending on
              the plan purchased. See the dealer guidelines and sample terms and
              conditions for complete coverage details.
            </p>
          </Col>
        </Row>
      )}
      {/* {accordionContents
            .filter(filterSearch)
            .map((accord, i) => <Accordion key={i} id={i} open={i === activeAccord} {...accord} onToggle={onToggle} />)} */}
    </>
  );
}
export default ComfortShieldprogramFaqs;
